import { MentionContentCustomizationEnum } from '../../Mentions/enums/mention-content-customization.enum';
import { TopMentionsMetadataModel } from './top-mentions-metadata.model';
import { InsightsDisplayNameEnum } from '../../Mentions/enums/insights-display-name.enum';


export class TopMentionsMetadataShareableModel {
    mentionContent: MentionContentCustomizationEnum;
    metadata: TopMentionsMetadataModel;
    showInsights: boolean;
    insightsNameDisplay: InsightsDisplayNameEnum;
    customInsightsName: string;
    timezone: string;
    currencyRate: number;
    preferredCurrency: string;
    highlightKeywords: boolean;

    constructor(
        mentionContent: MentionContentCustomizationEnum,
        metadata: TopMentionsMetadataModel,
        showInsights: boolean,
        insightsNameDisplay: InsightsDisplayNameEnum,
        customInsightsName: string,
        timezone: string,
        currencyRate: number,
        preferredCurrency: string,
        highlightKeywords: boolean
    ) {
        this.mentionContent = mentionContent;
        this.metadata = metadata;
        this.showInsights = showInsights;
        this.insightsNameDisplay = insightsNameDisplay;
        this.customInsightsName = customInsightsName;
        this.timezone = timezone;
        this.currencyRate = currencyRate;
        this.preferredCurrency = preferredCurrency;
        this.highlightKeywords = highlightKeywords;
    }
}
